import { useFormContext } from "react-hook-form";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

interface AlignmentOption {
  icon: IconType;
  type: string;
}

export const AlignmentField = ({
  name,
  options,
  label,
}: {
  name: string;
  options: AlignmentOption[] | ReadonlyArray<AlignmentOption>;
  label: string;
}) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();
  const { watch, setValue } = useFormContext();
  const value = watch(name);

  return (
    <div
      className={classNames("items-center", {
        "flex w-full justify-between": !isPropertiesPanelV2,
        "grid grid-cols-3": isPropertiesPanelV2,
      })}
    >
      <label className="form-group__label text-dark text-xs font-normal">
        {label}
      </label>
      <div
        className={classNames(
          "bg-tertiary col-span-2 flex items-center gap-px rounded-xl p-1",
          {
            "justify-start": !isPropertiesPanelV2,
            "justify-between": isPropertiesPanelV2,
          },
        )}
      >
        {options.map(button => (
          <button
            key={button.type}
            type="button"
            className={classNames(
              "flex items-center justify-center rounded-lg p-1.5",
              {
                "bg-primary": value === button.type,
                "bg-transparent": value !== button.type,
              },
            )}
            onClick={() => setValue(name, button.type)}
          >
            <Icon type={button.icon} size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};
